import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.optionNewPage || initialState;

export const selectOptionTypeData = createSelector(
    [selectDomain],
    state => state.optionTypeData,
);

export const selectLoading = createSelector(
    [selectDomain],
    state => state.loading,
);

export const selectLoadingTypes = createSelector(
    [selectDomain],
    state => state.loadingTypes,
);
